'use strict';

var React = require('react');

var SvgCalendarTimeMinor = function SvgCalendarTimeMinor(props) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    viewBox: "0 0 20 20"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M6 2a1 1 0 0 1 1 1v1h4v-1a1 1 0 1 1 2 0v1h1a2 2 0 0 1 2 2v4.257a4.48 4.48 0 0 0-2-.23v-2.027h-10v7h6.028c.081.734.34 1.415.732 2h-6.76a2 2 0 0 1-2-2v-9a2 2 0 0 1 2-2h1v-1a1 1 0 0 1 1-1Z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M14.5 18c-1.93 0-3.5-1.57-3.5-3.5s1.57-3.5 3.5-3.5 3.5 1.57 3.5 3.5-1.57 3.5-3.5 3.5Zm0-6a.5.5 0 0 0-.5.5v2.32a.5.5 0 0 0 .214.402l1.014.71a.5.5 0 1 0 .573-.819l-.801-.56v-2.053a.5.5 0 0 0-.5-.5Z"
  }));
};

exports.SvgCalendarTimeMinor = SvgCalendarTimeMinor;
